var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('highlight-container',{attrs:{"id":"pricing","fluid":"","title":_vm.title,"subtitle":_vm.content,"alignment":"center","even":""}},[_c('HubspotForm',{attrs:{"form-id":"2106f0fe-cdfb-4ff5-9898-0cb7630979b0","on-form-submit":function () {
        this$1.$analytics('Formulário', 'sent-B2C ', 'indicacao-marca');
      }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }